<template>
  <!-- <div class="column-search is-flex-grow-1"> -->
  <div class="field-search field has-addons">
    <input
      type="search"
      v-model="mSearchTerm"
      v-on:keyup.13="startSearch"
      class="input"
      :placeholder="placeHolderText"
    />

    <button
      @click="startSearch"
      class="button is-primary"
      :class="{ 'is-loading': isSearching }"
    >
      <span class="icon">
        <font-awesome-icon :icon="['fas', 'search']" />
      </span>
      <span>{{$t('Components.SearchBar.Icon_Search')}}</span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    isSearching: {
      default: false,
      type: Boolean
    },

    placeHolderText: {
      default: "",
      type: String
    },

    searchTerm: {
      default: "",
      type: String
    }
  },

  data() {
    return {
      mSearchTerm: this.searchTerm
    };
  },

  methods: {
    startSearch() {
      this.$emit("startSearch", this.mSearchTerm);
    },

    clearSearch() {
      this.mSearchTerm = "";
      this.startSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
// .column-search {
//   ma
//   .field {
//     display: flex;
//     flex-direction: row;
//     .control-input {
//       flex: 1;
//     }
//   }
// }
</style>
